












































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";
import CategoryPicker from "./CategoryPicker.vue";
import { bidTypes } from "../dictionary";
import { delStore } from "@/service/step-five";

@Component({ components: { CategoryPicker } })
export default class BusinessInfo extends Vue {
  @Prop({ required: true }) data!: any[];
  @State bidType!: number;

  rules = {
    business_type: [{ required: true, message: "请选择业务类型" }],
    sname: [{ required: true, message: "请填写经营名称" }],
    settle_type: [{ required: true, message: "请选择结算方式" }],
    store_type: [{ required: true, message: "请选择经营类型" }],
    cat_list: [{ required: true, message: "请添加经营类目" }],
  };
  columns = [
    {
      title: "一级类目",
      dataIndex: "cname_1",
    },
    {
      title: "二级类目",
      dataIndex: "cname_2",
    },
    {
      title: "三级类目",
      dataIndex: "cname_3",
    },
    {
      title: "操作",
      key: "action",
      scopedSlots: { customRender: "action" },
    },
    {
      title: "设置主营类目",
      key: "main-cate",
      scopedSlots: { customRender: "main-cate" },
    },
  ];
  pickerVisible = false;
  currentStore: any = {};

  get columns2() {
    const columns = [...this.columns];
    columns.splice(3, 0, {
      title: "扣点比例",
      dataIndex: "points_rate",
    });
    return columns;
  }

  get settleType() {
    // 供应商类型为“境内POP店铺”、“跨境POP店铺，则结算方式的枚举值写死为“按扣点结算”
    // 供应商类型为“一件代发供应商“、“经销供应商“，则结算方式的枚举值写死为“按成本价结算”
    if ([2, 6, 7, 8].includes(this.bidType)) return 1;
    if ([3, 4].includes(this.bidType)) return 2;
    return undefined;
  }

  get settleTypeTip() {
    return `（您是${(bidTypes as any)[this.bidType]}，无需选择结算方式）`;
  }

  getDefaultSettleType(store: any) {
    if (store.apply_status === 8) {
      //兼容一件代发转pop供应商后新增店铺时，保持原有店铺数据不变的情景
      this.$set(store, "settle_type", store.settle_type);
    } else {
      if (this.bidType !== 5) {
        this.$set(store, "settle_type", this.settleType);
      }
    }
  }

  handleDelete(item: any, store: any) {
    const list = store.cat_list;
    list.splice(list.indexOf(item), 1);
    if (item.is_main) {
      store.main_cate_id = "";
    }
  }

  setAsMain(item: any, store: any) {
    store.main_cate_id = item.cat_id;
    store.cat_list.forEach((cat: any) => {
      this.$set(cat, "is_main", cat.cat_id === item.cat_id ? 1 : 0);
    });
  }

  addCategories(store: any) {
    this.currentStore = store;
    this.pickerVisible = true;
  }

  onSelect(selected: any[]) {
    this.currentStore.cat_list.push(...selected);
  }

  addNewStore() {
    this.data.push({ cat_list: [] });
  }

  removeStore(index: number, store: any) {
    if (!store.id) {
      this.data.splice(index, 1);
      return;
    }
    this.$confirm({
      title: "温馨提示",
      content: "该经营主体已录入，确认删除吗？",
      onOk: async () => {
        await delStore(store.id);
        this.data.splice(index, 1);
      },
    });
  }

  validate() {
    return Promise.all(
      (this.$refs.form as any).map((form: any) => form.validate())
    );
  }
}
